import tbTable from './tb-table.component'
import './tb-when-scrolled/tb-when-scrolled.module'

export default angular
  .module('tb.table', ['tb.when-scrolled'])
  .component('tbTable', tbTable)
  .name
